import { useDocumentsByClientIdsLazyQuery } from '@graphql/generated';
import {
  resolveDocumentUrl,
  ResolvableDocument,
} from '@utils/resolveDocumentUrl';

export const useResolveDocumentUrl = () => {
  const [fetchDocumentsByClientIds] = useDocumentsByClientIdsLazyQuery();

  const resolve = (doc: ResolvableDocument): Promise<string | null> =>
    resolveDocumentUrl(doc, async (clientId) => {
      // network-only: a cache-first read can serve an already-expired
      // presigned URL from the Apollo cache, defeating the expiry check
      // this fetch exists to satisfy.
      const { data } = await fetchDocumentsByClientIds({
        variables: { clientIds: [clientId] },
        fetchPolicy: 'network-only',
      });
      return data?.documentsByClientIds?.[0]?.file?.url;
    });

  return { resolveDocumentUrl: resolve };
};
